<template>
    <div class="page-wrapper">
        <LoginForm></LoginForm>
    </div>
</template>

<script>
    import LoginForm from '../components/partials/LoginForm';

    export default {
        data() {
            return {
                hasRedirect: this.$auth.redirect()
            }
        },

        beforeCreate() {
            if(this.$route.query.ac) {
                localStorage.setItem('access_code', this.$route.query.ac);
            }

            if(this.$auth.check()) {
                if(this.$route.query.ac) {
                    this.$router.push({name: 'order', query: {'auto': 1}});
                } else {
                    this.$router.push({name: 'order'});
                }
            }
        },

        mounted() {
            document.querySelector('header').classList.add('solid');
            window.events.$emit('finishedLoading');
        },

        destroyed() {
            document.querySelector('header').classList.remove('solid');
        },

        components: {
            LoginForm
        }
    }
</script>
